var themeColors = ['error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary'];
// eslint-disable-next-line no-underscore-dangle
var _isCssColor = function (color) {
    return !!color && !!color.match(/^(#|var\(--|(rgb|hsl)a?\()/);
};
// eslint-disable-next-line no-underscore-dangle
var _isThemeColor = function (color) {
    return !!color && themeColors.includes(color);
};
export var useColor = function (props) {
    var isCssColor = _isCssColor(props.color);
    var isThemeColor = _isThemeColor(props.color);
    var colorStyle = {
        color: isCssColor && props.color,
    };
    return {
        isCssColor: isCssColor,
        isThemeColor: isThemeColor,
        colorStyle: colorStyle,
    };
};
